import { createSelector } from 'react-sweet-state';

import type { FieldId } from '../../../../common/types/form/form-fields';
import { filterVisibleSections } from '../../../../common/utils/sections/conditions';
import { getFieldIdsUnderSection } from '../../../../common/utils/sections/utils';
import type { FormRendererState } from '../../types';
import { currentValuesSelector } from '../current-values';

/**
 * Selector to extract all field IDs from visible sections only.
 */
export const getAllVisibleFieldIdsSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	void,
	string[]
> = createSelector(
	(state: FormRendererState) => state.formSections,
	(state: FormRendererState) => state.formFields,
	(state: FormRendererState) => currentValuesSelector(state),
	(formSections, formFields, currentValues): FieldId[] => {
		const visibleSections = filterVisibleSections(formSections, formFields, currentValues);
		return visibleSections.flatMap(getFieldIdsUnderSection);
	},
);
